import { actionProps } from "@/lib/controlAnalytics";
import { buttonClass } from "@/components/common/controls";
import { TailorButton } from "@/components/site/PostingActions";
import { SectionCard } from "./parts";

/** The fit card for a visitor: what adding a resume would show, and the way to add one. */
export default function VisitorFit({
    postingId,
    job,
    onAddResume,
}: {
    postingId: string;
    job: { title: string; company?: string | null };
    onAddResume: () => void;
}) {
    return (
        <SectionCard
            className="gap-3.5"
            title="Fit"
            caption="The keywords the posting names, against what your resume says."
        >
            <p className="m-0 text-ui text-fg-muted [text-wrap:pretty]">
                Add your resume to see which of its keywords you already have, and get a resume
                tailored to this posting. 10 a month, free.
            </p>
            <div className="flex flex-wrap gap-2">
                <TailorButton postingId={postingId} job={job} size="page" />
                <button
                    {...actionProps("resume_upload_opened", {
                        source: "PostingDetail",
                        posting_id: postingId,
                    })}
                    type="button"
                    onClick={onAddResume}
                    className={buttonClass("secondary", "page")}
                >
                    Add my resume
                </button>
            </div>
        </SectionCard>
    );
}
